<template>
    <ul v-if="tabs.length > 0"
        class="my-tabs">
        <li v-for="item in tabs"
            class="my-tabs__item"
            :key="item.paneName">
            <button :disabled="disabled"
                :class="{
                    active: value === item.paneName,
                    disabled
                }"
                @click="itemClick(item)">
                {{ item.name }}
            </button>
        </li>
    </ul>
</template>

<script lang="ts">
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'

export default createComponent({
    props: {
        value: {
            type: String,
            required: true
        },
        tabs: {
            type: Array,
            required: true,
            default: () => [],
            validator(val) {
                return val.every(item => typeof item.name === 'string' && typeof item.paneName === 'string')
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        itemClick(item) {
            this.$emit('input', item.paneName)
            this.$emit('tab-click', item)
        }
    }
})
</script>

<style lang="scss" scoped>
.my-tabs {
    display: inline-flex;
    padding: 4px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;

    &__item {
        flex: none;
        border-radius: 4px;
        overflow: hidden;
        font-size: 14px;

        button {
            height: 20px;
            line-height: 20px;
            text-align: center;
            padding: 4px 20px;
            color: #333;
            box-sizing: content-box;
            transition: all .25s;
            cursor: pointer;

            &.active {
                background-color: #cceae7;
                color: #009688;
                font-weight: bold;
            }
        }
    }
}
</style>
